const dateNumbers = {
  Jan: '01',
  Feb: '02',
  Mar: '03',
  Apr: '04',
  May: '05',
  Jun: '06',
  Jul: '07',
  Aug: '08',
  Sep: '09',
  Oct: '10',
  Nov: '11',
  Dec: '12'
}

const monthText = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec'
}

// format this date example: Tue Dec 29 2020 11:49:00 GMT+0800 (Philippine Standard Time) to 2020-12-29T11:49:00
export const formatDate = (date = ' ') => {
  const newDate = date.toString()?.split(' ')
  const year = newDate[3]
  const month = dateNumbers[newDate[1]]
  const day = newDate[2]
  return `${year}-${month}-${day}`
}

// format this date example: Tue Dec 29 2020 11:49:00 GMT+0800 (Philippine Standard Time) to Dec 29, 2020
export const formatUTCDateToLocalDate = date => {
  if (date) {
    const convertedDate = new Date(date)
    const newDate = convertedDate.toString()?.split(' ')
    const year = newDate[3]
    const month = newDate[1]
    const day = newDate[2]
    const time = newDate[4]
    return `${month} ${day}, ${year} ${time}`
  } else {
    return '-'
  }
}

// format this date example: 2020-06-17T00:00:00.000Z to Jun 17, 2020
export const formatDueDate = date => {
  if (date) {
    const newDate = date?.toString()?.split('-')
    const year = newDate[0]
    const month = monthText[newDate[1]]
    const day = newDate[2].split('T')[0]
    const time = newDate[2].split('T')[1]
    const hrMinSec = time.split('.')[0]
    return `${month} ${day}, ${year} ${hrMinSec}`
  } else {
    return ''
  }
}

// format
export const formatChecksDate = date => {
  if (date) {
    const newDate = date?.split('/')
    const month = monthText[newDate[0]]
    const day = newDate[1]
    const year = newDate[2]
    return `${month} ${day}, ${year}`
  } else {
    return ''
  }
}
